import React from "react";
import { observer } from "mobx-react";
import { FacilityOrderTemplatePreviewTemplate } from "themes/application/facility-order/pages";
import { setCurrentView } from "core/utils";
import { FacilityOrderTemplatePreviewViewStore } from "application/facility-order/stores";

@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplatePreviewViewStore(rootStore, componentProps), "facilityOrderTemplatePreviewStore")
@observer
class FacilityOrderTemplatePreview extends React.Component {
	render() {
		return <FacilityOrderTemplatePreviewTemplate {...this.props} />;
	}
}

export default FacilityOrderTemplatePreview;